module.exports = __webpack_public_path__ + "img/hrm-judith-sm.cc0e30b.png";